import React from "react";
import ApacheLineChart from "./ApacheLineChart";
import ApacheBarChart from "./ApacheBarChart";
import ApacheScatterChart from "./ApacheScatterChart";
import ApacheVerticalBarChart from "./ApacheVerticalBarChart";
import ApacheStackedBarChart from "./ApacheStackedBarChart";
import ApacheHeatMatrixChart from "./ApacheHeatMatrixChart";
import "./charts.css";



const ApacheCharts = ({chartType, chartDataSet, showLegend = false}) => {

  return (
    <div className="apacheChartParentDiv">
      {chartType === 'lineChart' && <ApacheLineChart
        title=""
        xAxisData={chartDataSet?.axisData || []}
        series={chartDataSet?.seriesValue || []}
        tooltipXAxisData={chartDataSet?.axisData?.tooltipData}
        showLegend={showLegend}
        xisData={chartDataSet?.axisData}
      />}
      {chartType === 'horizontalBarChart' && <ApacheBarChart
        title=""
        yAxisData={chartDataSet?.axisData || []}
        series={chartDataSet?.seriesValue || []}
      />}
      {chartType === 'scatterPlot' && <ApacheScatterChart
        title=""
        xAxisData={chartDataSet?.axisData?.data}
        tooltipXAxisData={chartDataSet?.axisData?.tooltipData}
        series={chartDataSet?.seriesValue || []}
        xisData={chartDataSet?.axisData}
      />}
      {chartType === 'verticalBarChart' && <ApacheVerticalBarChart
        title=""
        xAxisData={chartDataSet?.axisData || []}
        tooltipXAxisData={chartDataSet?.axisData?.tooltipData}
        series={chartDataSet?.seriesValue || []}
      />}
      {chartType === 'stackedBarChart' && <ApacheStackedBarChart
        title=""
        xAxisData={chartDataSet?.axisData || []}
        series={chartDataSet?.seriesValue || []}
        tooltipXAxisData={chartDataSet?.axisData?.tooltipData}
        showLegend={showLegend}
      />}
      {chartType === 'heatMatrixChart' && <ApacheHeatMatrixChart
        title=""
        xAxisData={chartDataSet?.axisData || []}
        series={chartDataSet?.seriesValue || []}
        tooltipXAxisData={chartDataSet?.axisData?.tooltipData}
        showLegend={false}
      />}
    </div>
  );
};

export default React.memo(ApacheCharts);
